export const isObjectArrayEqual = (arr1, arr2) => {
  return (JSON.stringify(arr1) === JSON.stringify(arr2))
}